// 設計基準解析度 — 取自 Unity ProjectSettings（橫版 1920×1080；直版推估 1080×1920，
// 精確值待從 Unity 直版 CanvasScaler 參考解析度核對）。Web canvas 預設 960×600。
// 供資源製作與佈局比例參考；實際渲染採等比縮放至視窗。

export type Orientation = 'landscape' | 'portrait'

export interface DesignSize {
  readonly width: number
  readonly height: number
}

export const DESIGN: Readonly<Record<Orientation, DesignSize>> = {
  landscape: { width: 1920, height: 1080 },
  portrait: { width: 1080, height: 1920 },
}

export function orientationOf(width: number, height: number): Orientation {
  return width >= height ? 'landscape' : 'portrait'
}

/**
 * 佈局度量（佔螢幕高度比例）— 橫/直版的單一事實來源。
 * 底部操作列高度、頂部保留，由各場景共用以保持對位一致。
 */
export interface LayoutMetrics {
  readonly barHeight: number
  readonly topReserve: number
}

export function layoutMetrics(orientation: Orientation): LayoutMetrics {
  // 直版：底部操作列加高（容納置中大圓 SPIN），頂部保留加大（露出 Bonus 轉盤 / Logo / 老虎）。
  return orientation === 'portrait'
    ? { barHeight: 0.17, topReserve: 0.09 }
    : { barHeight: 0.15, topReserve: 0.05 }
}

/** 可隨視窗/方向重新佈局的場景元件。 */
export interface Resizable {
  resize(width: number, height: number, orientation: Orientation): void
}
